import { useSelector } from "react-redux";
import { ValidOpenstackResource } from "../../../../types";
import { State } from "../../../../../selectors/state";
import { valuesOf } from "../../../../../shared-functions/objects";
import { Port } from "../../../ports/types";

const useConnectedSubnets = (router: ValidOpenstackResource) => {
  const portsObject = useSelector((state: State) => state.ports);
  const subnetsObject = useSelector((state: State) => state.subnets);

  const portsList: Port[] = valuesOf(portsObject.PORTS_LIST).filter(
    (port) =>
      port.project_id === router.project_id &&
      port.region === router.region &&
      port.device_id === router.id &&
      port.device_owner === "network:router_interface",
  );

  const subnetIds = portsList.flatMap(
    (port) => port.fixed_ips?.map((ip) => ip.subnet_id) ?? [],
  );

  const subnets = valuesOf(subnetsObject.SUBNETS_LIST).filter((subnet) =>
    subnetIds.includes(subnet?.id),
  );

  return subnets;
};

export default useConnectedSubnets;
